import React, { useEffect, useRef, useState } from 'react';

function About({ data }) {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const profilepic = data ? `images/${data.image}` : '';

  return (
    <section 
      id="about" 
      ref={sectionRef}
      style={{
        backgroundImage: `linear-gradient(rgba(0, 50, 70, 0.55), rgba(0, 50, 70, 0.6)), url(${process.env.PUBLIC_URL}/images/header-background3.jpeg)`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? 'translateY(0)' : 'translateY(30px)',
        transition: 'opacity 0.8s ease-out, transform 0.8s ease-out'
      }}
    >
      <div className="row">
        <div className="three columns">
          <img 
            className="profile-pic" 
            src={profilepic} 
            alt="Elisabete Monteiro"
            loading="lazy"
          />
        </div>
        <div className="nine columns main-col">
          <h2>About me</h2>
          <p>
            I am Brazilian, a post-graduated teacher and lawyer. Since graduating in Modern Languages - Portuguese / English and correlated literatures, I have acquired extensive experience in the teaching field in all age groups of regular education, pre-university entrance exams and foreign language institutes, as well as in private lessons of English and Portuguese for foreigners both for teenagers and adults. I am a passionate communicator and avid learner.
          </p>
          
          <h2>Languages:</h2>
          <p>
            Portuguese: Qualified native teacher
            <br />
            English: Fluent (Cambridge CPE)
            <br />
            Spanish: Advanced
            <br />
            French: Basic
          </p>
        </div>
      </div>
    </section>
  );
}

export default About;
